import { Title } from '@angular/platform-browser';
import {Component, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import * as moment from 'moment-timezone'
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Gradient Able 5+';

  constructor(private router: Router,
              private titleService: Title) 
              { 
                this.setTitle(environment.title);
              }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      moment.tz.setDefault("America/Sao_Paulo");

      if (!(evt instanceof NavigationEnd)) {
        return;
      }

      window.scrollTo(0, 0);
    });
  }

  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }
}
